import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { CELL_LAYOUT_TYPE } from './Types';
import './EnumDialogEditor.scss';

const UNDEFINED_VALUE = 'UNDEFINED_VALUE';

const EnumDialogEditor = (props) => {
  const { value, onValueChange, editor, className, style } = props;
  const handleChange = (event) => {
    onValueChange(event.target.value === UNDEFINED_VALUE ? undefined : event.target.value, editor);
  };
  const [namedValues] = useState(() => {
    return Array.isArray(editor.namedValues) ? editor.namedValues : editor.namedValues(props);
  });

  const options = !Array.isArray(editor.namedValues) && editor.dependsOn
    && editor.namedValues(props) || namedValues;

  if ((editor.layout === CELL_LAYOUT_TYPE) || (!editor.layout && (!editor.namedValues.length || editor.namedValues.length > 3))) {
    return (
      <FormControl
        className={classnames('grb-enumfilter-editor', 'grb-enumfiltercell-editor', className)}
        style={style}
      >
        <InputLabel shrink htmlFor={editor.name}>{editor.title}</InputLabel>
        <Select
          value={value}
          onChange={handleChange}
          inputProps={{
            name: `${editor.name}`,
            id: `${editor.name}`,
          }}
          input={<Input name={editor.name} />}
          displayEmpty
          name={editor.name}
          autoComplete="off"
        >
          {options.map(tr => <MenuItem value={tr.value === undefined ? UNDEFINED_VALUE : tr.value} key={tr.label}>{tr.label}</MenuItem>)}
        </Select>
      </FormControl>
    );
  }
  return (
    <FormControl
      component="fieldset"
      className={classnames('grb-enumfilter-editor', 'grbrsm-enum-filter-radios-editor', className)}
      style={style}
    >
      <RadioGroup
        aria-label="DialogEditor"
        name="editor.name"
        value={value}
        onChange={handleChange}
      >
        {options.map(tr => <FormControlLabel value={tr.value} control={<Radio />} key={tr.name} label={tr.label} />)}
      </RadioGroup>
    </FormControl>
  );
};

EnumDialogEditor.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
    PropTypes.shape({}),
  ]),
  editor: PropTypes.shape({
    title: PropTypes.string,
    name: PropTypes.string,
    layout: PropTypes.string,
    namedValues: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.shape({})),
      PropTypes.func,
    ]),
    dependsOn: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  onValueChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.shape({}),
};

EnumDialogEditor.defaultProps = {
  value: UNDEFINED_VALUE,
  className: undefined,
  style: undefined,
};

export default EnumDialogEditor;
